/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
//import { combineReducers } from 'redux'
import trace from './trace'


export default trace
